import { Component, OnInit, ViewChild } from "@angular/core";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { MasterService } from "../../Shared/app.Masters.Service";
import { LmsService } from "../../_Lms/services/lms.service";
import { RequestModel } from "../../Shared/Models/app.MasterRequestModel";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
declare var $: any;

@Component({
    selector: "app-mst-state-list",
    templateUrl: "./mst-state-list.component.html",
    styleUrls: ["./mst-state-list.component.scss"],
    standalone: false
})
export class MstStateListComponent implements OnInit {
  private data: any;
  private _MasterService;
  showSpinner: boolean = false;
  dataSource: any;
  JsonData: any[] = [];
  loading: boolean = false;
  displayedColumns: string[] = [
    "StateId",
    "State_Name",
    "Code",
    "StateCode",
    "GSTCode",
    "Region_Count",
    "Action",
  ];
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  StateList: any = [];
  ZoneListDropdown: any = [];
  SaveStateRequestModel: RequestModel = new RequestModel();
  editStateObj: any = {};
  selectedZoneId: any = "";

  constructor(
    private dataSharingService: DataSharingService,
    public snackBar: MatSnackBar,
    private MasterService: MasterService,
    private LmsService: LmsService
  ) {
    this._MasterService = MasterService;
    this.data = JSON.parse(sessionStorage.getItem("currentUser"));
  }

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  ngOnInit() {
    this.dataSharingService.HeaderTitle.next("State List");
    this.getStateList();
    this._MasterService.GetZoneListDropdown().subscribe((result) => {
      this.ZoneListDropdown = JSON.parse(JSON.stringify(result));
    });
  }

  getStateList() {
    this.showSpinner = true;
    this._MasterService.GetState().subscribe((result) => {
      this.StateList = JSON.parse(JSON.stringify(result));
      this.dataSource = new MatTableDataSource(this.StateList);
      this.JsonData = result;
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.showSpinner = false;
    });
  }

  exportexcelNew(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById("State_List") as HTMLTableElement;
    const worksheetName = "MASTER_STATE_LIST"; // Set the desired worksheet name here
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement("a");

    // Generate the data URI for the Excel file
    downloadLink.href = uri + base64(format(template, ctx));

    // Set the file name for the download
    downloadLink.download = worksheetName + ".xls";

    // Trigger the download
    downloadLink.click();
  }

  onEditState(row: any) {
    this.editStateObj = { ...row };
    this.selectedZoneId = row.State_ZoneId;
    $("#EditStateModal").modal("show");
    $("#EditStateModal").css("z-index", "1050");
  }

  onSaveState() {
    this.SaveStateRequestModel.StateId = this.editStateObj.StateId;
    this.SaveStateRequestModel.ZoneId = parseInt(this.selectedZoneId) || 0;
    this.LmsService
      .SaveStateMaster(this.SaveStateRequestModel)
      .subscribe({
        next: (response) => {
          if (response[0].CODE >= 0) {
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: response[0].MSG,
              ...this.configSuccess,
            });
            $("#EditStateModal").modal("hide");
            this.onCloseModal();
            this.getStateList();
          } else {
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: response[0].MSG,
              ...this.configSuccess,
            });
          }
        },
        error: (err) => {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "Failed to save state. Please try again.",
            ...this.configSuccess,
          });
        }
      });
  }

  onCloseModal() {
    this.editStateObj = {};
    this.selectedZoneId = "";
    $("#EditStateModal").modal("hide");
  }
}
